var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lead-Detail_Activity_V3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.377,
    height: 20.377,
    viewBox: "0 0 20.377 20.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lead-Detail-Page-_Basic-Details-_v3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-information"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M9.17,0V3.057H4.075V18.339H2.038V16.3H0v4.075H20.377V16.3H18.339v2.038H16.3V3.057H11.207V0ZM6.113,5.093h8.151V18.339H11.207V14.263H9.17v4.076H6.113ZM9.17,8.151h2.038V6.112H9.17Zm0,4.075h2.038V10.188H9.17Z",
    fill: "#bcbcbc",
    fillRule: "evenodd"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyName);
export default __webpack_public_path__ + "static/media/company-name.c64c8b3ae4ddaeecd94ee56e3111941c.svg";
export { ForwardRef as ReactComponent };